/**
 * Decodes a JSON string to a JavaScript value.
 * Returns null for empty strings instead of throwing an error.
 *
 * @param data - JSON string to parse
 * @returns Parsed JavaScript value or null if data is empty
 *
 * @example
 * ```ts
 * import { JSONDecode } from "@pdfking/tfunc"
 *
 * const obj = JSONDecode('{"name":"John","age":30}')
 * console.log(obj.name) // "John"
 *
 * const empty = JSONDecode("")
 * console.log(empty) // null
 * ```
 */
export const JSONDecode = (data: string) => (data ? JSON.parse(data) : null)
